import React, { useState, useEffect, useRef } from "react";

import countriesList from "../../static/countries.json";
import { parsePhoneNumber } from "libphonenumber-js";

import { ReactComponent as ArrowDonw } from "../../static/images/arrow_down.svg";

import "./style.scss";

const CountryCode = ({
  currentCountry,
  changeCurrentCountry,
  queryValue,
  styled,
}) => {
  const [countySearchToggle, setCountrySearchToggle] = useState(false);
  const [countries, setCountries] = useState("");

  const allCountriesRef = useRef([]);
  const inputRef = useRef(null);

  let queryCountry = queryValue ? parsePhoneNumber(`+${queryValue}`) : "";

  const currentCodeStyle = {
    ...(styled ? styled : {}),
    ...(currentCountry.dial_codeLength > 2 && currentCountry.dial_codeLength < 4
      ? { width: "80px" }
      : currentCountry.dial_codeLength >= 4
        ? { width: "100px" }
        : { width: "80px" }),
  };

  // getting list of countries

  const fetchCountries = (code) => {
    const formatedCountris = countriesList
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((item) => ({
        ...item,
        code: item.code.toLowerCase(),
      }));

    allCountriesRef.current = formatedCountris;

    setCountries(formatedCountris);

    let currentCountry = formatedCountris.filter((item) => {
      return code === item.code;
    });

    changeCurrentCountry((prev) => ({
      ...prev,
      dial_code: queryValue
        ? `+${queryCountry.countryCallingCode}`
        : currentCountry[0].dial_code,
      dial_codeLength: currentCountry[0].dial_code.length,
    }));
  };

  const filterCountries = (value) => {
    setCountries(
      allCountriesRef.current.filter(
        (country) =>
          country.name.toLowerCase().includes(value.toLowerCase()) ||
          country.dial_code.includes(value),
      ),
    );
  };

  useEffect(() => {
    changeCurrentCountry((prev) => ({
      ...prev,
      code: queryValue ? queryCountry.country.toLowerCase() : "us",
    }));

    fetchCountries("us");
  }, []);

  useEffect(() => {
    if (countySearchToggle && inputRef.current) {
      inputRef.current.focus();
    }
  }, [countySearchToggle]);

  //  outter click toggle

  const toggleRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (toggleRef.current && !toggleRef.current.contains(event.target)) {
        setCountrySearchToggle(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      {currentCountry ? (
        <div
          className="current-country"
          style={currentCodeStyle}
          onClick={() => {
            setCountrySearchToggle((prev) => !prev);
          }}
        >
          <div className="country-image">
            <img
              src={`https://flagcdn.com/16x12/${currentCountry.code}.png`}
            />{" "}
          </div>
          <div className="number-code">
            <span>({currentCountry.dial_code})</span>
          </div>
          <ArrowDonw className="arrow-down" />
        </div>
      ) : null}

      {countySearchToggle === true ? (
        <div className="select-countries-container" ref={toggleRef}>
          <div className="search-country">
            <input
              type="text"
              ref={inputRef}
              placeholder="Search..."
              onChange={(e) => {
                filterCountries(e.target.value);
              }}
            />
          </div>
          <div className="select-countries">
            <ul>
              {countries.map((item) => {
                return (
                  <li
                    key={item.code}
                    onClick={() => {
                      setCountrySearchToggle("");
                      changeCurrentCountry({
                        code: item.code,
                        dial_code: item.dial_code,
                        dial_codeLength: item.dial_code.length,
                      });
                    }}
                  >
                    <div className="county-flag">
                      <img src={`https://flagcdn.com/16x12/${item.code}.png`} />
                    </div>
                    <div className="number-code">{item.dial_code}</div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default CountryCode;
